import { baseSeriesMark } from "../base/constant";

export const pieSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    pie: {
        name: "pie",
        type: "arc"
    },
    labelLine: {
        name: "labelLine",
        type: "path"
    }
});
//# sourceMappingURL=constant.js.map
